@if (!isLocked(options[participant.id], participant)) {
    @switch (isStartingPrice(options[participant.id]!)) {
        @case (true) {
            <span class="fixture-pick-odds">{{ sitecore.betslip.messages.StartingPrice }}</span>
        }
        @case (false) {
            @if (isSports) {
                <span class="fixture-pick-odds">{{ options[participant.id].price | msExternalPriceFormatter }}</span>
            } @else {
                <div class="pick-odds">
                    <div class="fixture-pick-odds">
                        <span class="fixture-pick-text option-value">{{ options[participant.id].nativePrice | msNativePriceFormatter }}</span>
                    </div>
                    <div class="previous-odds">
                        @for (price of options[participant.id]!.priceHistory; track $index) {
                            <span>{{ price | msExternalPriceFormatter }}</span>
                        }
                    </div>
                </div>
            }
        }
    }
} @else {
    <div class="fixture-pick-odds result-odds"><vn-icon name="theme-locked-i" size="16" class="option-lock-icon"></vn-icon></div>
}
@if (isSports && crmPromotedOptionIdsMap && crmPromotedOptionIdsMap[options[participant.id]!.id]) {
    <ms-promotion-badge class="no-title"></ms-promotion-badge>
}
<span class="fixture-label fixture-pick-title">{{ participant.name | msTranslate }}</span>
